import { GradientType, PropertyValueData } from '../../types';
import { Gradients } from '../../../../potree/materials/Gradients';

export const isValidGradient = (value?: PropertyValueData): value is GradientType => {
  if (!value) return false;
  return typeof value === 'string' && value in Gradients;
};
